<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild" :style="`background: ${backgroundText}`">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/logo.png" @click="toHome">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <a @mouseenter="openOrGotoNav(item, true, index)" @click="openOrGotoNav(item)" style="cursor: pointer;">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </a>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
      <div class="header-right">
        <div class="search-icon__wrap">
            <img class="search-icon search-white" @click="search" src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/index-search.png"/>
            <img class="search-icon search-black" @click="search" src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/index-search-black.png"/>
        </div>
        <div class="change-lan">
          <a @click="changeEn('cn')">中文</a> <span style="position: relative; top: -1px;">|</span> <a  @click="changeEn('en')">EN</a>
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <!-- <span :class="menuClass"></span> -->
          <img class="menu-icon-mobile menu-icon-mobile-down" src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/menu-mobile.png" />
        </div>
        <img class="center-block" src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/logo.png" alt="logo" @click="toHome">
        <div class="change-lan">
          <a @click="changemobileEn('cn')">中文</a> <span style="position: relative; top: -1px;">|</span> <a  @click="changemobileEn('en')">EN</a>
        </div>
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu mobile-header text-center">
        <!-- {{menuName}}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div> -->

        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <div class="mobile-search">
            <img src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/index-close-mobile.png" data-toggle="collapse" data-target="#menu" class="index-close-mobile" />
            <div class="search-wrapper-mobile">
              <img class="index-search-mobile" data-target="#menu" data-toggle="collapse" @click="toSearch" src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/index-search-mobile.png" />
              <input class="mobile-input fs-24" v-model="searchText" />
            </div>
          </div>
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name, item.path)"
          >
            <router-link :to="item.children.length > 0 ? '' : item.path" v-if="item.children.length > 0">
              <span data-toggle="collapse" data-target="#menu">{{item.name}}</span>
              <i class="underline"></i>
              <div class="header-nav-m-menu-wrapper second-menu">
                <span :class="getMobileArrowClass(item.path)"></span>
              </div>
            </router-link>

            <router-link :to="item.children.length > 0 ? '' : item.path" data-toggle="collapse" data-target="#menu" v-else>
              <span >{{item.name}}</span>
              <i class="underline"></i>
            </router-link>

            <ul class="children-menu" v-if="isShowChildren(item)" :id="`menu${item.path}`">
              <li v-for="child in item.children" :key="child.path"
                :data-toggle="`collapse`"
                :data-target="isShowChildren(item) ? '#menu' : `#menu${item.path}`"
              >
                <router-link :to="child.path">
                  {{child.name}}
                  <i class="underline"></i>
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div class="header-menu">
      <div v-if="isShowNav" @mouseleave="isShowNav = false">
        <div class="parent-title fs-22">{{ currentNav.name }}</div>
        <div class="children-list">
          <div class="children-item fs-22" v-for="item in currentNav.children" :key="item.path" @click="toLink(item)">{{ item.name }}</div>
        </div>
      </div>
      <div v-if="isShowSearch" @mouseleave="isShowSearch = false" class="search-content">
        <input type="search" class="search-input fs-26" placeholder="Search" v-model="searchText" @keydown.enter="toSearch">
        <img class="search-content__icon" src="https://grow-website-ol.oss-accelerate.aliyuncs.com/assets/new-images/index-search-black.png" @click="toSearch" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "HOME",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "HOME",
          path: "/",
          children: []
        },
        {
          name: "SHAREHOLDERS & TEAM",
          path: "/team-intro",
          children: []
        },
        {
          name: "PRODUCTS & SERVICES",
          path: "/bunisess",
          children: [
            {
              name: "MULTI STRATEGY",
              path: "/multi-assets"
            },
            {
              name: "REAL ESTATE INVESTMENT",
              path: "/credit-property"
            },
            {
              name: 'MULTI FAMILY OFFICE',
              path: '/multi-family'
            }
          ]
        },

        {
          name: "RESEARCH",
          path: "/company-research",
          children: []
        },

        {
          name: "INSIGHTS & NEWS",
          path: "/company-news",
          children: [
            {
              name: "INSIGHTS",
              path: "/company-option"
            },
            {
              name: "NEWS",
              path: "/company-news"
            },
            {
              name: "CORPORATE HONORS",
              path: "/company-honor"
            }
          ]
        },

        {
          name: "CONTACT",
          path: "/concat",
          children: [
            {
              name: "CONTACT US",
              path: "/contact-us"
            },
            {
              name: "JOIN US",
              path: "/join-us"
            }
          ]
        },
      ],
      currentNav: {},
      isShowNav: false,
      backgroundText: 'rgba(255, 255, 255, .8)',
      mobileMenuStatus: {},
      searchText: '',
      isShowSearch: false
    };
  },

  watch: {
    isShowNav (newVal) {
      if (newVal) {
        this.isShowSearch = !this.isShowNav
      }
    },
    isShowSearch (newVal) {
      if (newVal) {
        this.isShowNav = !this.isShowSearch
      }
    }
  },

  mounted () {
    document.addEventListener('scroll', (e) => {
      let scrollTop = document.documentElement.scrollTop
      let innerHeight = window.innerHeight
      // let rate = (parseInt(scrollTop) / parseInt(innerHeight)) / 10
      // rate = rate.toFixed(1)
      // console.log(rate, innerHeight, scrollTop)
      if (scrollTop > (innerHeight - 200)) {
        this.backgroundText = `rgba(255, 255, 255, 1)`
      } else {
        this.backgroundText = `rgba(255, 255, 255,.8)`
      }
    })
  },

  methods: {
    navClick(index, name, path) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
      if (this.mobileMenuStatus[path]) {
        this.$set(this.mobileMenuStatus, path, false)
      } else {
        this.$set(this.mobileMenuStatus, path, true)
      }
    },

    search () {
      // this.isShowNav = true
      this.isShowSearch = true
    },

    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },

    toSearch () {
      this.$router.push({
        path: '/company-news',
        query: {
          keyword: this.searchText
        }
      })
    },

    openOrGotoNav (item, isHover, index) {
      if (index) this.navIndex = index
      let { children } = item
      if (children && children.length > 0) {
        this.isShowNav = true
        this.currentNav = {
          ...item
        }
      } else {
        if (isHover) {
          this.isShowNav = false
          return
        }
        this.$router.push(item.path)
      }
    },

    toLink (item) {
      this.$router.push(item.path)
      this.isShowNav = false
    },

    getMobileArrowClass (key) {
      if (this.mobileMenuStatus[key]) return 'glyphicon glyphicon-menu-up'
      else return 'glyphicon glyphicon-menu-down'
    },

    isShowChildren ({ path, children }) {
      if (children.length > 0 && this.mobileMenuStatus[path]) return true
      else return false
    },

    changeEn (type) {
      let { href } = location
      if (type == 'cn') {
        href = href.replace('en-', 'cn-')
      }
      if (type == 'en') {
        href = href.replace('cn-', 'en-')
      }
      location.href = href
    },
    changemobileEn (type) {
      let { href } = location
      if (type == 'cn') {
        href = href.replace('en-', 'cn-')
      }
      if (type == 'en') {
        href = href.replace('cn-', 'en-')
      }
      location.href = href
    },

    toHome () {
      sessionStorage.setItem('navIndex', 0)
      // this.$router.replace('/home')
      location.href="/en-offical/#/home"
    }
  },


};
</script>

<style scoped>

  .container {
    position: relative;
    width: 100%;
    /* padding: 0 280px 0 147px; */
  }

  /* .header-menu {
    padding: 38px 200px 100px 200px;
  } */

  .parent-title {
    padding: 38px 200px 0 200px;
    font-weight: 700;
    color: #3E3A39;
  }

  .children-list {
    display: flex;
    /* margin-top: 59px; */
    padding: 59px 200px 100px 200px;
  }

  .children-item {
    font-weight: 500;
    color: #EB9B6A;
    margin-right: 130px;
    border-bottom: 1px solid #EB9B6A;
    cursor: pointer;
  }

  .header-right {
    position: absolute;
    display: flex;
    align-items: center;
    /* top: 50%; */
    margin-top: 40px;
    right: 0px;
    z-index: 10;
    display: flex;
  }

  .search-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .search-icon__wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    padding: 5px;
    /* margin-right: 30px; */
  }

  .search-white {
    display: none;
  }

  .search-black {
    display: block;
  }

  .search-icon__wrap:hover {
    background-color: #F09B71
  }

  .search-icon__wrap:hover .search-white {
    display: block;
  }

  .search-icon__wrap:hover .search-black {
    display: none;
  }

  .change-lan {
    width: 78px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    border-radius: 4px;
    border: 1px solid #787574;
    font-size: 13px;
    font-weight: 500;
    color: #3E3A39;
    /* margin-left: 56px; */
    cursor: pointer;
  }

  .change-lan a {
    color: #3E3A39;
    cursor: pointer;
  }

  .search-input {
    width: 100%;
    height: 60px;
    border-radius: 6px;
    border: 1px solid #858487;
    outline: none;
    padding: 0 20px;
    background: transparent;
  }

  .search-content {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 50px 0;
    width: 70%;
    margin: 0 auto;
  }

  .search-content__icon {
    position: absolute;
    right: 20px;
    width: 30px;
    height: 30px;
    top: 50%;
    margin-top: -15px;
    cursor: pointer;
  }
</style>

<style scoped>
/* 顶部 */
#header {
  background: rgba(255, 255, 255, .8);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all ease 0.6s;
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
  max-width: 1500px;
  /* width: 1366px; */
  padding: 0px 150px 0px 0px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  /* width: 100px; */
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: auto;
  height: 73px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 1200px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #3E3939;
  font-size: 16px;
  font-weight: 500;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #EB9A6A;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #EB9A6A;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #EB9A6A;
  text-decoration: none;
  /* border-bottom: 2px solid #EB9A6A; */
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  /* display: block; */
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header {
    background: #f4f4f4;
    position: relative;
  }

  #header .header-nav-m {
    position: fixed;
    width: 100%;
    background: #f4f4f4;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 60px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 105px;
    /* height: 45px; */
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 0px;
    font-size: 20px;
    line-height: 50px;
    /* background: #474747; */
    position: relative;
    /* background-color: RGBA(14, 25, 41, .9); */
  }

  /* .mobile-header {
    height: 100px !important;
    background-color: RGBA(14, 25, 41, .9);
  } */
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    left: 0px;
    margin-top: -15px;
    width: 50px;
    height: 40px;
    z-index: 999999;
    font-size: 12px;
    /* color: #000; */
  }

  .second-menu {
    left: unset !important;
    right: -30px;
    margin-top: -27px !important;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    /* background: #474747; */
    background-color: RGBA(14, 25, 41, .9);
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    /* height: 40px;
    line-height: 40px; */
    border-bottom: 1px solid #4A5264;
    position: relative;
    text-align: left;
    padding: 0 50px;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a, .children-menu > li > a{
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    /* padding: 15px 0; */
    position: relative;
    display: inline-block;
    width: 100%;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }

  .mobile-search {
    display: flex;
    flex-direction: column;
    padding: 20px 30px;
  }

  .search-wrapper-mobile {
    position: relative;
    width: 100%;
  }

  .mobile-input {
    height: 36px;
    line-height: 36px;
    background: #172B54;
    border: 1px solid #fff;
    border-radius: 4px;
    padding: 0 20px 0 50px;
    display: flex;
    align-items: center;
    width: 100%;
    outline: none;
    line-height:36px;
  }

  .index-search-mobile{
    position: absolute;
    width: 16px;
    height: 16px;
    top: 50%;
    margin-top: -8px;
    left: 10px;
  }

  .index-close-mobile {
    width: 14px;
    height: 14px;
    margin-bottom: 20px;
  }

  .menu-icon-mobile {
    width: 24px !important;
    height: 24px !important;
    margin-top: 5px !important;
  }

  /* .menu-icon-mobile-down {
    transform: rotate(90deg);
    transition: .3s all;
  } */
}
</style>


<style scoped>
  @media screen and (max-width: 1366px) {
    #header .header-nav .header-nav-wrapper > li > a {
      font-size: 16px;
    }

    #header .header-nav .header-nav-logo img {
      height: 50px;
    }

    .container {
      padding-right: 180px;
    }

    .search-icon {
      width: 20px;
      height: 20px;
    }

    .search-icon__wrap {
      padding: 5px;
    }

    .change-lan {
      width: 70px;
      height: 20px;
      font-size: 16px;
      line-height: 20px;
      margin-left: 28px;
    }

    .header-right {
      /* margin-top: -10px; */
      right: 20px;
      width: 120px;
      /* margin-left: -15px; */
    }

    .change-lan {
      position: absolute;
      top: 50%;
      margin-top: -10px;
      right: 13px;
      font-size: 12px;
    }

      .search-input {
        height: 40px;
      }

      .search-content {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 30px 0;
        width: 70%;
        margin: 0 auto;
      }

      .search-content__icon {
        position: absolute;
        right: 20px;
        width: 20px;
        height: 20px;
        top: 50%;
        margin-top: -10px;
        cursor: pointer;
      }

      .children-list {
        padding: 30px 100px 50px 200px;
      }

      .children-item {
        margin-right: 70px;
      }

      .parent-title {
        padding: 19px 100px 0 200px;
      }

  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue